(function () {
  if (!customElements.get('vehicle-model-selector')) {
    class VehicleModelSelector extends HTMLElement {
      constructor() {
        super();
        // console.log('VehicleModelSelector initialized');
        this.mql = window.matchMedia('(min-width: 750px)');
        this.elements = {
          vehicleButton: this.querySelector('.disclosure__button'),
          vehiclePanel: this.querySelector('.disclosure__list-wrapper'),
          vehicleListScroll: this.querySelector('.disclosure__list-scroll'),
          search: this.querySelector('input[name="vehicle_filter"]'),
          resetButton: this.querySelector('.vehicle-filter .reset__button'),
          closeButton: this.querySelector('.vehicle-filter__reset-button'),
          clearButton: this.querySelector('.clear__button'),
          vehicleOptions: this.querySelectorAll('#vehicle-model-list .disclosure__item button'),
        };
        this.pendingVehicleOption = null;
        this.vehiclePointerStartY = 0;
        this.vehiclePointerHandled = false;
        this.syncVehicleStickyOffset = this.syncVehicleStickyOffset.bind(this);
        this.onVehiclePanelPointerDown = this.onVehiclePanelPointerDown.bind(this);
        this.onVehiclePanelPointerUp = this.onVehiclePanelPointerUp.bind(this);
        this.onVehiclePanelPointerCancel = this.onVehiclePanelPointerCancel.bind(this);
        this.addEventListeners();
        this.syncTriggerAccessibleName();
        window.addEventListener('resize', this.syncVehicleStickyOffset);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.syncVehicleStickyOffset);
      }

      syncTriggerAccessibleName() {
        const button = this.elements.vehicleButton;
        if (!button) return;
        const labelId = 'vehicle-model-label';
        const span = button.querySelector('#vehicle-model-value');
        const placeholder = ((span && span.getAttribute('data-label')) || button.getAttribute('data-label') || '').trim();
        const current = ((span && (span.dataset.optionText || span.textContent)) || '').trim();
        if (current && placeholder && current !== placeholder) {
          button.setAttribute('aria-labelledby', `${labelId} vehicle-model-value`);
        } else {
          button.setAttribute('aria-labelledby', labelId);
        }
        button.removeAttribute('aria-label');
      }

      addEventListeners() {
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.elements.vehicleButton.addEventListener('click', this.toggleSelector.bind(this, 'vehicle'));

        if (this.elements.vehiclePanel) {
          this.elements.vehiclePanel.addEventListener('pointerdown', this.onVehiclePanelPointerDown);
          this.elements.vehiclePanel.addEventListener('pointerup', this.onVehiclePanelPointerUp);
          this.elements.vehiclePanel.addEventListener('pointercancel', this.onVehiclePanelPointerCancel);
        }

        this.elements.vehicleOptions.forEach((option) => {
          option.addEventListener('click', (event) => {
            if (this.vehiclePointerHandled) return;
            this.onVehicleItemClick(event);
          });
        });

        if (this.elements.search) {
          this.elements.search.addEventListener('input', this.onSearchInput.bind(this));
          this.elements.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('pointerdown', (event) => event.preventDefault());
          this.elements.resetButton.addEventListener('click', this.onResetSearch.bind(this));
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.closeModal.bind(this));
        }

        if (this.elements.clearButton) {
          this.elements.clearButton.addEventListener('pointerdown', (event) => event.preventDefault());
          this.elements.clearButton.addEventListener('click', this.onClearSelection.bind(this));
        }

        document.addEventListener('click', this.handleOutsideClick.bind(this));
        this.toggleClearButton();
        this.toggleResetButton();
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.hidePanel('vehicle');
          // this.hidePanel('generation');
        }
      }

      isPanelOpen() {
        return this.elements.vehicleButton && this.elements.vehicleButton.getAttribute('aria-expanded') === 'true';
      }

      getVisibleOptions() {
        const panel = this.elements.vehiclePanel;
        if (!panel || panel.hasAttribute('hidden')) return [];
        return Array.from(panel.querySelectorAll('button.disclosure__link')).filter((item) => {
          if (item.hidden || item.getAttribute('aria-hidden') === 'true') return false;
          const itemRow = item.closest('.disclosure__item');
          if (itemRow && (itemRow.hidden || itemRow.style.display === 'none')) return false;
          return true;
        });
      }

      focusOption(which) {
        const options = this.getVisibleOptions();
        if (!options.length) return;
        const option = which === 'last' ? options[options.length - 1] : options[0];
        option.focus();
      }

      moveOptionFocus(key) {
        const options = this.getVisibleOptions();
        if (!options.length) return;

        let index = options.findIndex((item) => item === document.activeElement);
        if (key === 'Home') index = 0;
        else if (key === 'End') index = options.length - 1;
        else if (key === 'ArrowUp') index = index > 0 ? index - 1 : options.length - 1;
        else index = index < options.length - 1 ? index + 1 : 0;

        options[index].focus();
      }

      selectFocusedOption() {
        const options = this.getVisibleOptions();
        const focused = options.find((item) => item === document.activeElement);
        const option = focused || options[0];
        if (!option) return false;
        option.click();
        return true;
      }

      onVehiclePanelPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        const option = event.target.closest('button.disclosure__link');
        if (!option || !this.elements.vehiclePanel.contains(option)) {
          this.pendingVehicleOption = null;
          return;
        }
        this.pendingVehicleOption = option;
        this.vehiclePointerStartY = event.clientY;
      }

      onVehiclePanelPointerUp(event) {
        const option = this.pendingVehicleOption;
        this.pendingVehicleOption = null;
        if (!option || !this.elements.vehiclePanel.contains(option)) return;
        if (Math.abs(event.clientY - this.vehiclePointerStartY) > 12) return;

        this.vehiclePointerHandled = true;
        this.onVehicleItemClick({ target: option, suppressFocus: event.pointerType !== 'mouse' });
        setTimeout(() => {
          this.vehiclePointerHandled = false;
        }, 400);
      }

      onVehiclePanelPointerCancel() {
        this.pendingVehicleOption = null;
        this.vehiclePointerHandled = false;
      }

      onFocusOut(event) {
        if (this.contains(event.relatedTarget) || this.pendingVehicleOption) return;
        requestAnimationFrame(() => {
          if (this.contains(document.activeElement) || this.pendingVehicleOption) return;
          this.hidePanel('vehicle');
        });
      }

      onContainerKeyDown(event) {
        const key = event.key;
        const isSearch = event.target === this.elements.search;
        const isTrigger = event.target === this.elements.vehicleButton;
        const isOption = event.target.closest && event.target.closest('button.disclosure__link');

        if (key === 'Escape') {
          if (!this.isPanelOpen()) return;
          event.preventDefault();
          event.stopPropagation();
          this.hidePanel('vehicle');
          this.elements.vehicleButton.focus();
          return;
        }

        if (key === 'Enter' || key === ' ') {
          if (isSearch && key === ' ') return;
          if (isTrigger) {
            event.preventDefault();
            if (!this.isPanelOpen()) this.toggleSelector('vehicle', event);
            return;
          }
          if (!this.isPanelOpen()) return;
          event.preventDefault();
          this.selectFocusedOption();
          return;
        }

        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(key)) return;

        if (isTrigger && (key === 'ArrowDown' || key === 'ArrowUp')) {
          event.preventDefault();
          if (!this.isPanelOpen()) this.toggleSelector('vehicle', event);
          requestAnimationFrame(() => this.focusOption(key === 'ArrowUp' ? 'last' : 'first'));
          return;
        }

        if (isSearch && (key === 'ArrowDown' || key === 'ArrowUp')) {
          event.preventDefault();
          this.moveOptionFocus(key);
          return;
        }

        if (!this.isPanelOpen()) return;
        event.preventDefault();
        this.moveOptionFocus(key);
      }

      toggleSelector(type, event) {
        if (this.vehiclePointerHandled) return;
        if (event) {
          event.stopPropagation();
        }
        const button = this.elements.vehicleButton;
        const panel = this.elements.vehiclePanel;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          this.hidePanel(type);
          return;
        }

        DisclosurePanel.closeSiblings(panel, this);
        DisclosurePanel.show(panel, button);
        requestAnimationFrame(() => this.syncVehicleStickyOffset());

        const openedByPointer = event && typeof event.detail === 'number' && event.detail > 0;
        if (type === 'vehicle' && this.elements.search && this.mql.matches && openedByPointer) {
          this.elements.search.focus();
        }
      }

      syncVehicleStickyOffset() {
        const scrollEl = this.elements.vehicleListScroll;
        const panel = this.elements.vehiclePanel;
        if (!scrollEl || !panel) return;

        const filter = panel.querySelector('.vehicle-filter');
        const filterHeight = filter ? filter.offsetHeight : 0;
        scrollEl.style.maxHeight = filterHeight ? `calc(27.5rem - ${filterHeight}px)` : '27.5rem';
      }

      getOptionSearchText(optionLink) {
        return (optionLink.dataset.optionText || optionLink.textContent || '').toLowerCase().trim();
      }

      updateVehicleTrigger(optionButton) {
        const valueSpan =
          this.elements.vehicleButton.querySelector('#vehicle-model-value') ||
          this.elements.vehicleButton.querySelector('span[data-label]');
        if (!valueSpan) return;

        const vehicleMarkup = optionButton.querySelector('.cart-item-notes__vehicle');
        const optionText = (optionButton.dataset.optionText || optionButton.textContent || '').trim();
        const placeholder = valueSpan.getAttribute('data-label') || '';

        valueSpan.innerHTML = '';
        if (vehicleMarkup) {
          valueSpan.appendChild(vehicleMarkup.cloneNode(true));
        } else {
          valueSpan.textContent = optionText;
        }

        if (placeholder) valueSpan.setAttribute('data-label', placeholder);
        if (optionText) {
          valueSpan.dataset.optionText = optionText;
        } else {
          delete valueSpan.dataset.optionText;
        }

        if (optionButton.dataset.vehicleOdooSku) {
          valueSpan.setAttribute('data-vehicle-odoo-sku', optionButton.dataset.vehicleOdooSku);
        } else {
          valueSpan.removeAttribute('data-vehicle-odoo-sku');
        }
      }

      syncVehicleGroupsVisibility() {
        this.querySelectorAll('.disclosure__group').forEach((group) => {
          const items = group.querySelectorAll('.disclosure__item');
          const hasVisible = Array.from(items).some((item) => item.style.display !== 'none');
          group.style.display = hasVisible ? '' : 'none';
        });
      }

      filterOptions() {
        const searchValue = this.elements.search?.value.toLowerCase().trim() || '';
        const searchRegex = searchValue ? new RegExp(searchValue, 'i') : null;
        const options = this.querySelectorAll('.disclosure__item');

        options.forEach((option) => {
          const optionLink = option.querySelector('button.disclosure__link');
          const optionText = this.getOptionSearchText(optionLink);
          const isMatch = !searchRegex || searchRegex.test(optionText);
          option.style.display = isMatch ? '' : 'none';
        });

        this.syncVehicleGroupsVisibility();
      }

      onSearchInput() {
        this.filterOptions();
        this.toggleResetButton();
      }

      toggleResetButton() {
        const button = this.elements.resetButton;
        if (!button) return;
        const hasValue = !!(this.elements.search && this.elements.search.value);
        button.hidden = !hasValue;
        button.classList.toggle('hidden', !hasValue);
      }

      onResetSearch(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.elements.search) return;
        this.elements.search.value = '';
        this.filterOptions();
        this.toggleResetButton();
        this.elements.search.focus();
      }

      closeModal(event) {
        event.preventDefault();
        event.stopPropagation();
        this.hidePanel('vehicle');
        // this.hidePanel('generation');
      }

      hidePanel(type) {
        DisclosurePanel.hide(this.elements.vehiclePanel, this.elements.vehicleButton);
      }

      onSearchKeyDown(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      }

      onVehicleItemClick(event) {
        const target = event.target.closest('button.disclosure__link') || event.target;
        const selectedValue = target.dataset.value;
        const selectedVehicleSize = target.dataset.vehicleSize;

        this.querySelectorAll('.disclosure__link[aria-selected="true"]').forEach((button) => {
          button.setAttribute('aria-selected', 'false');
          button.classList.remove('selected');
        });

        target.setAttribute('aria-selected', 'true');
        target.classList.add('selected');

        this.updateVehicleTrigger(target);
        this.syncTriggerAccessibleName();
        this.toggleClearButton();
        if (this.elements.search) {
          this.elements.search.value = '';
          this.filterOptions();
          this.toggleResetButton();
        }
        this.hidePanel('vehicle');
        if (!event.suppressFocus) {
          this.elements.vehicleButton.focus();
        }

        // console.log('Vehicle item clicked:', { selectedValue, selectedVehicleSize, generationData });

        // Update Shopify's variant selector (radio buttons) - only if they exist on the page
        const variantRadios = document.querySelectorAll('input[type="radio"][name="Size"]');
        if (variantRadios.length > 0) {
          const matchingVariant = Array.from(variantRadios).find(
            (radio) => this.handleize(radio.value) === this.handleize(selectedVehicleSize)
          );

          if (matchingVariant) {
            matchingVariant.checked = true;
            matchingVariant.dispatchEvent(new Event('change', { bubbles: true }));
            // console.log('Updated variant selection:', matchingVariant.value);
          } else {
            // Only warn if variant radios exist but no match was found
            console.warn('Matching variant radio button not found');
          }
        }
        // If variant radios don't exist (e.g., in custom forms), silently skip this step

        // Handle generation data
        // if (generationData) {
        //   this.populateGenerationDropdown(generationData);
        // } else {
        //   this.hideGenerationDropdown();
        // }

        // Dispatch a custom event for vehicle selection
        this.dispatchEvent(
          new CustomEvent('vehicleSelected', {
            bubbles: true,
            detail: {
              value: selectedValue,
              label: (target.dataset.optionText || target.textContent || '').trim(),
              vehicleSize: selectedVehicleSize,
            },
          })
        );
      }

      // populateGenerationDropdown(generationData) {
      //   const generations = generationData.split(',').map((gen) => gen.trim());
      //   this.elements.generationList.innerHTML = '';
      //   generations.forEach((gen) => {
      //     const li = document.createElement('li');
      //     li.className = 'disclosure__item';
      //     const button = document.createElement('button');
      //     button.type = 'button';
      //     button.className = 'disclosure__link uppercase';
      //     button.setAttribute('role', 'option');
      //     button.setAttribute('aria-selected', 'false');
      //     button.textContent = gen;
      //     button.addEventListener('click', this.onGenerationItemClick.bind(this));
      //     li.appendChild(button);
      //     this.elements.generationList.appendChild(li);
      //   });
      //   this.elements.generationSelector.style.display = 'block';
      // }

      // hideGenerationDropdown() {
      //   this.elements.generationSelector.style.display = 'none';
      //   this.elements.generationList.innerHTML = '';
      //   this.elements.generationButton.querySelector('span').textContent = 'Select Generation';

      //   // Dispatch a custom event to indicate that generation is cleared
      //   this.dispatchEvent(
      //     new CustomEvent('generationSelected', {
      //       bubbles: true,
      //       detail: {
      //         generation: '',
      //       },
      //     })
      //   );
      // }

      // onGenerationItemClick(event) {
      //   const selectedGeneration = event.target.textContent;
      //   this.elements.generationButton.querySelector('span').textContent = selectedGeneration;
      //   this.hidePanel('generation');

      //   // console.log('Selected generation:', selectedGeneration);

      //   // Dispatch a custom event for generation selection
      //   this.dispatchEvent(
      //     new CustomEvent('generationSelected', {
      //       bubbles: true,
      //       detail: {
      //         generation: selectedGeneration,
      //       },
      //     })
      //   );
      // }

      toggleClearButton() {
        const button = this.elements.clearButton;
        if (!button) return;
        const hasSelection = !!this.querySelector('.disclosure__link[aria-selected="true"]');
        button.hidden = !hasSelection;
        button.classList.toggle('hidden', !hasSelection);
      }

      resetVehicleTrigger() {
        const valueSpan =
          this.elements.vehicleButton?.querySelector('#vehicle-model-value') ||
          this.elements.vehicleButton?.querySelector('span[data-label]');
        if (!valueSpan) return;

        const placeholder =
          valueSpan.getAttribute('data-label') || this.elements.vehicleButton.getAttribute('data-label') || '';
        valueSpan.innerHTML = '';
        valueSpan.textContent = placeholder;
        delete valueSpan.dataset.optionText;
        valueSpan.removeAttribute('data-vehicle-odoo-sku');
      }

      onClearSelection(event) {
        event.preventDefault();
        event.stopPropagation();

        this.querySelectorAll('.disclosure__link[aria-selected="true"]').forEach((button) => {
          button.setAttribute('aria-selected', 'false');
          button.classList.remove('selected');
        });

        this.resetVehicleTrigger();
        this.syncTriggerAccessibleName();
        this.hidePanel('vehicle');
        this.toggleClearButton();

        this.dispatchEvent(
          new CustomEvent('vehicleSelected', {
            bubbles: true,
            detail: { value: '', label: '', vehicleSize: '' },
          })
        );
      }

      handleize(str) {
        return String(str || '')
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/-$/, '')
          .replace(/^-/, '');
      }
    }

    customElements.define('vehicle-model-selector', VehicleModelSelector);
  }
})();
